import * as React from "react";

import { ContentSection } from "../Layout/ContentSection";
import { HeadingSection } from "../Layout/HeadingSection";
import { GoldCoin } from "../Toolbar/GoldCoin";
import { SilverCoin } from "../Toolbar/SilverCoin";
import { RLink } from "../DesignSystem/RLink";
import { Paragraph } from "../DesignSystem/formatting/Paragraph";

export const ExplainGoldPage = (): JSX.Element => {
  return (
    <div>
      <HeadingSection title="What is gold?">
        TL;DR: It's like XP but you can spend it.
      </HeadingSection>

      <ContentSection>
        <Paragraph>
          Gold is awarded for participating in the Chips community.
        </Paragraph>

        <Paragraph>
          If you leave lots of helpful comments and reviews, vote and don't
          make <em>too</em> many joke tracks, you'll find yourself with tons
          of gold! You'll be rich, I say! Well, at least on Chips you will be.
        </Paragraph>

        <Paragraph>
          <h3>
            Ways to get gold.{" "}
            <small>
              1 <GoldCoin /> = 20 <SilverCoin />
            </small>
          </h3>
        </Paragraph>

        <ul>
          <li>
            <strong>
              +2 <SilverCoin />
            </strong>
            : Vote on an entry.{" "}
          </li>
          <li>
            <strong>
              +10 (or more) <SilverCoin />
            </strong>
            : Leave a review on an entry.{" "}
          </li>
          <li>
            <strong>
              +5 <GoldCoin />
            </strong>
            : Vote on every track in a compo.
          </li>
          <li>
            <strong>
              Up to +10 <GoldCoin />, based on score
            </strong>
            : Get a track past judgement.{" "}
          </li>
        </ul>

        <Paragraph>
          <h3>
            Where to spend <GoldCoin />.
          </h3>
        </Paragraph>

        <ul>
          <li>
            <strong>
              10 <GoldCoin />
            </strong>
            : You may submit an additional entry to a compo.
          </li>
          <li>
            <strong>
              30 <GoldCoin />
            </strong>
            : Set your profile picture to animated avatar. (Better get it
            while it's still technically free!)
          </li>
          <li>
            <strong>
              30 <GoldCoin />
            </strong>
            : Add a message to the footer taglines! (This exists now! Go to
            the edit profile page.)
          </li>
          <li>
            <strong>
              60 <GoldCoin />
            </strong>
            : Run a DayCompo! Get 3 other people to back your idea and PM me.
          </li>
          <li>
            <strong>
              50 <GoldCoin />
            </strong>
            :{" "}
            <span style={{ color: "darkgray" }}>
              Slightly darker gray role on Discord.
            </span>
          </li>
          <li>
            <strong>
              70 <GoldCoin />
            </strong>
            :{" "}
            <span style={{ color: "gray" }}>
              Even darker gray role on Discord.
            </span>{" "}
            Great, now no one will be able to tell you apart from mods.{" "}
            <em>Whose idea was this again...</em>
          </li>
          <li>
            <strong>
              100 <GoldCoin />
            </strong>
            :{" "}
            <span style={{ color: "purple" }}>
              Purple color in Discord. Wow, you definitely have gold to burn.
            </span>
          </li>
          <li>
            <strong>
              200 <GoldCoin />
            </strong>
            :{" "}
            <span style={{ color: "cyan" }}>
              Light blue color in Discord. Everyone will worship the ground
              you walk. Holy smokes.
            </span>
          </li>
        </ul>

        <h2>
          <RLink to="/edit/profile">Go Back.</RLink>
        </h2>
      </ContentSection>
    </div>
  );
};
